import script from "./EvseTracelessOta.vue?vue&type=script&lang=ts&setup=true"
export * from "./EvseTracelessOta.vue?vue&type=script&lang=ts&setup=true"

import "./EvseTracelessOta.vue?vue&type=style&index=0&id=fbb25872&lang=scss"

const __exports__ = script;

export default __exports__